/**
 * StickerGetRes 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { StickerData } from './sticker_data'

/**
 * StickerGetRes
 */
export interface StickerGetRes {
  /** 表情包数据 */
  data?: StickerData
}

/**
 * StickerGetRes Schema
 */
export const StickerGetResSchema: SchemaDefinition = {
  properties: {
    data: {
      $ref: 'StickerData',
      description: '表情包数据',
      label: '表情包数据',
    },
  },
  type: 'object',
}
